webpackJsonp([4],{

/***/ 1:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closest = closest;
exports.wrap = wrap;
exports.mYYYY = mYYYY;
exports.commas = commas;
exports.inMegabytes = inMegabytes;
exports.json = json;
exports.price = price;
/**
 * Lib
 * Tools and such
 */

/**
 * Find Closest parent of element matching selector
 * @param {elementNode} el
 * @param {string} selector
 */

function closest(el, selector) {
  var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;

  var desiredEl = el;
  while (desiredEl) {
    if (matchesSelector.call(desiredEl, selector)) {
      break;
    }
    desiredEl = desiredEl.parentElement;
  }
  return desiredEl || false;
}

/**
 * Wrap element with a div with a class
 * @param {elementNode} node
 * @param {string} className
 */

function wrap(node, className) {
  var wrapperClass = className || null;
  var container = document.createElement('div');
  if (className) {
    container.className = wrapperClass;
  }
  container.innerHTML = node.outerHTML;
  node.parentElement.insertBefore(container, node);
  node.parentElement.removeChild(node);
}

// Vimeo API

var Vimeo = exports.Vimeo = {

  /**
  * Play a Vimeo video
  * @param {elementNode} el
  */
  play: function play(el) {
    if (!el) return false;
    return el.contentWindow.postMessage({ method: 'play' }, el.src);
  },

  /**
  * Pause a Vimeo video
  * @param {elementNode} el
  */
  pause: function pause(el) {
    if (!el) return false;
    return el.contentWindow.postMessage({ method: 'pause' }, el.src);
  }
};

// Vue filters

function mYYYY(val) {
  var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var date = new Date(val);
  return monthNames[date.getMonth()] + ' ' + date.getFullYear();
}

function commas(val) {
  if (val > 0) {
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  return false;
}

function inMegabytes(val) {
  return (val / Math.pow(1024, 2)).toFixed(1) + ' MB';
}

function json(val) {
  return JSON.stringify(val);
}

function price(val) {
  if (val > 0) {
    var inCents = val / 100;
    var withCommas = inCents.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + withCommas.replace(/\.00/g, '');
  }
  return false;
}

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Navigation
 * JS components for navigation
 */

var Nav = {};

Nav.nav = function () {
  var navEl = document.querySelector('#ms-nav');
  navEl.classList.add('is-initialized');
  var navSwitchEl = document.querySelector('#ms-nav-switch');
  navSwitchEl.addEventListener('click', function (e) {
    document.documentElement.classList.toggle('is-menu-open');
    e.preventDefault();
  });
};

// <select> navigation

Nav.selectNav = function (selector) {
  selector = selector || 'select';
  var selectEl = document.querySelector(selector);
  selectEl.selectedIndex = 0;
  selectEl.addEventListener('change', function (e) {
    if (selectEl.value[0] === 'h' || selectEl.value[0] === '/') location.replace(e.target.value);else if (selectEl.value[0] === '#') location.hash = selectEl.value;
  });
};

exports.default = Nav;

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(17);

var _vue2 = _interopRequireDefault(_vue);

var _Term = __webpack_require__(63);

var _Term2 = _interopRequireDefault(_Term);

var _nav = __webpack_require__(3);

var _nav2 = _interopRequireDefault(_nav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_nav2.default.nav(); /**
                      * Home
                      */

var app = new _vue2.default({
  el: '#app-root',
  components: {
    'v-term': _Term2.default
  }
});

/***/ }),

/***/ 63:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/babel-loader/lib!../node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Term.vue
var Term = __webpack_require__(64);
var Term_default = /*#__PURE__*/__webpack_require__.n(Term);

// CONCATENATED MODULE: ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2594b5aa","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Term.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.open}},[_vm._t("body")],2),_vm._v(" "),_c('div',{staticClass:"modal",class:{ 'is-viewing': _vm.isLoaded && _vm.isOpen },on:{"click":_vm.close}},[_c('div',{staticClass:"modal-inner",on:{"click":function($event){$event.stopPropagation();_vm.close($event)}}},[_c('div',{staticClass:"pl1"},[_c('h3',{staticClass:"dw-ref"},[_vm._v(_vm._s(_vm.code))]),_vm._v(" "),_c('h1',{staticClass:"dw-title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"content content--padded content--c",domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._v(" "),_c('div',{staticClass:"tac mt1 mb2 pl1 pr1"},[_c('a',{staticClass:"btn",attrs:{"href":_vm.url}},[_vm._v("Learn more")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-screen",on:{"click":_vm.close}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_components_Term = (esExports);
// CONCATENATED MODULE: ./components/Term.vue
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Term_default.a,
  selectortype_template_index_0_components_Term,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_Term = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lib = __webpack_require__(2);

module.exports = {
  data: function data() {
    return {
      code: '',
      content: '',
      isLoaded: false,
      isOpen: false,
      title: '',
      url: ''
    };
  },

  props: ['term'],
  created: function created() {
    var vue = this;
    document.addEventListener('keydown', function (e) {
      if (e.which === 27) {
        vue.close();
      }
    });
  },
  methods: {
    close: function close() {
      this.isOpen = false;
      _lib.Vimeo.pause();
      document.body.classList.remove('is-modal-viewing');
    },

    open: function open() {
      this.isOpen = true;
      this.fetch();
      _lib.Vimeo.play();
      document.body.classList.add('is-modal-viewing');
    },

    fetch: function fetch() {
      var _this = this;

      var vue = this;
      var xhr = new XMLHttpRequest();
      xhr.timeout = 10000;
      var url = '/api/0.1/term/' + this.term;
      xhr.open('GET', url);
      xhr.send(null);
      xhr.onload = function (e) {
        if (xhr.readyState === 4) {
          if ([200].indexOf(xhr.status) != -1) {
            var data = JSON.parse(xhr.responseText);

            vue.code = data.code;
            vue.content = data.content.replace(/\<iframe.+?\>/i, '<div class="video">$&').replace(/\<\/iframe\>/i, '</iframe></div>');
            vue.isLoaded = true;
            vue.title = data.title;
            vue.url = '/design-wise#' + _this.term;
          }
        }
      };
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ })

},[60]);


// WEBPACK FOOTER //
// home-75ae922eb9ab6eb8b15b.js